// Module
var code = `<footer class="CIT-footer CIT-footer--with-sub-footer">
    <div class="Container">
      <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner CIT-border--bottom">
          <div class="CIT-footer__logo-container">
            <a href="#" class="CIT-logo__container">
              <img [src]="footerLogoImageSrc" class="CIT-logo CIT-footer__logo" alt="Forever First">
            </a>
          </div>
          <div class="CIT-footer__contact">
            <a (click)="tools.openUrl('https://www.firstcitizens.com/hosted/community-association-banking-customer-support')"
               class="CIT-footer__link-header">
              Contact Us
            </a>
          </div>
        </div>
        <div class="mdc-layout-grid__inner">
          <div>
            <div class="CIT-footer__sub">
              <div class="CIT-footer--copyright">
                <img [src]="ehlLogoImageSrc" alt="ehl-white">
                <img [src]="fdicLogoImageSrc" alt="member-fdic-white">
                <p>&copy;<span class="CIT-year">{{copyrightYear}}</span> First-Citizens Bank & Trust Company. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mdc-layout-grid__inner">
          <div>
            <div class="CIT-footer__sub">
              <div class="CIT-footer__sub-links">
                <ul>
                  <li>
                    <a href="https://www.firstcitizens.com/terms-of-use" target="" rel="" title="Terms of Use">
                      <div class="mdc-button__ripple"></div><span class="mdc-button__label">Terms of Use</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.firstcitizens.com/privacy-security" target="" rel="" title="Privacy and Security">
                      <div class="mdc-button__ripple"></div><span class="mdc-button__label">Privacy &amp; Security</span>
                    </a>
                  </li>
                  <li>
                    <a title="Your Privacy Choices" (click)="openConsent(); \$event.stopPropagation()">
                      <div class="mdc-button__ripple"></div><span class="mdc-button__label">Your Privacy Choices </span>
                      <img tid="privacyChoicesLogo" [src]="privacyChoicesImageSrc">
                    </a>
                  </li>
                  <li>
                    <a href="https://www.firstcitizens.com/accessibility-statement" target="" rel="" title="Accessibility">
                      <div class="mdc-button__ripple"></div><span class="mdc-button__label">Accessibility</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
`;
// Exports
module.exports = code;